import { SubAPI } from "./SubAPI";

export class Util extends SubAPI {

    getBackgroundTaskStatus(props: {
        task: string;
        withResult?: boolean;
    }) {
        return this.fetcher.get<{
            done: boolean;
            result?: any;
        }>("/api/util/get-background-task", props)
    }
}